module.exports = __webpack_public_path__ + "img/html5.5fa0ef96.png";